module.exports = __webpack_public_path__ + "img/military_hq-stage_3.2.78d769dc.jpg";